import { OrgPensionSchemeRequest } from './types';

export const GET_ORGANISATION_USERS = (
  orgId: string,
  page: number = 1,
  limit: number = 15,
  searchKeyword: string = ''
) => {
  const params = new URLSearchParams();
  params.set('page', page.toString());
  params.set('limit', limit.toString());
  if (searchKeyword) {
    params.set('filter[user.name]', searchKeyword);
  }
  return `/base/organizations/${orgId}/users?` + `${params.toString()}`;
};

export const GET_ORGANIZATION_CLIENTS = (
  orgPensionSchemeRequest: OrgPensionSchemeRequest
) => {
  const params = new URLSearchParams();
  if (orgPensionSchemeRequest?.page) {
    params.set('page', orgPensionSchemeRequest.page.toString());
  }
  if (orgPensionSchemeRequest?.limit) {
    params.set('limit', orgPensionSchemeRequest.limit.toString());
  }
  if (orgPensionSchemeRequest.searchKeyword) {
    params.set('filter[name]', orgPensionSchemeRequest.searchKeyword);
  }

  return (
    `/base/organizations/${orgPensionSchemeRequest.orgId}/pension-scheme/organizations?` +
    `${params.toString()}`
  );
};

export const POST_ORGANIZATION_USER = (orgId: string) => {
  return `/base/organizations/${orgId}/users`;
};

export const DELETE_ORGANIZATION_USER = (orgId: string, userId: string) => {
  return `/base/organizations/${orgId}/users/${userId}`;
};

export const PUT_ORGANIZATION_USER = (orgId: string, userId: string) => {
  return `/base/organizations/${orgId}/users/${userId}`;
};

export const GET_ROLES = `/base/roles`;
